

























import { ScheduleType } from '@tt4b/ttam-enums';
import { defineComponent, computed } from '@vue/composition-api';
import TtamScheduleStartTimeDatePicker from '../starttime-datepicker/index.vue';
import TtamScheduleEndTimeDatePicker from '../endtime-datepicker/index.vue';
import { PropType } from 'vue';

const name = 'ttam-schedule-daterange-timepicker';

export default defineComponent({
  name,
  components: {
    TtamScheduleStartTimeDatePicker,
    TtamScheduleEndTimeDatePicker,
  },
  props: {
    value: {
      type: Array as PropType<string[]>,
    },
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
    startTimeDisabled: {
      type: Boolean,
      default: false,
    },
    endTimeDisabled: {
      type: Boolean,
      default: false,
    },
    timezone: {
      type: String,
      default: 'Asia/Shanghai',
    },
    timezoneOffset: {
      type: Number,
      default: 0,
    },
    bottomShortcutsOptions: {
      type: Object,
      default: () => ({}),
    },
    disableScrollControl: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const _scheduleStartTime = computed({
      get: () => props.startTime || props.value?.[0] || '',
      set: v => {
        const finalV = [v, props.value?.[1]];
        emit('change', finalV);
        emit('input', finalV);
        emit('start-time-change', v);
      },
    });
    const _scheduleEndTime = computed({
      get: () => props.endTime || props.value?.[1] || '',
      set: v => {
        const finalV = [props.value?.[0], v];
        emit('change', finalV);
        emit('input', finalV);
        emit('end-time-change', v);
      },
    });

    return {
      name,
      ScheduleType,
      _scheduleStartTime,
      _scheduleEndTime,
    };
  },
});
